<template>
    <div>
        <div style="width: 100%; height:100vh;border-bottom: 1px solid;">
            <div class="header-title">
                <div class=" display-flex header-title-one">
                    <div>
                        <span class="first">姓名</span>
                        <span>{{tableData.userName}}</span>
                    </div>
                    <div>
                        <span class="first">性别</span>
                        <span v-if="tableData.sex === 1">男</span>
                        <span v-else>女</span>
                    </div>
                    <div>
                        <span class="first">任务性质</span>
                        <span v-if="tableData.userTask.type == 1">考核</span>
                        <span v-else>练习</span>

                    </div>
                </div>

                <div class="header-title-two ">
                    <div class="first guidance">指导意见</div>
                    <div class="suggest">
                        <el-input
                                :disabled="permissions == 2"
                                type="textarea"
                                autosize
                                placeholder="请输入内容"
                                v-model="textarea">
                        </el-input>
                    </div>
                    <div style="line-height: 33px;width: 10%;margin-left: 10%" @click="submit(0)">
                        <el-button size="mini" type="primary">一键指导</el-button>
                    </div>
                    <div style="line-height: 33px;width: 10%" v-if="permissions == 3" @click="submit(1)">
                        <el-button size="mini" type="primary">提交</el-button>
                    </div>
                </div>
            </div>
            <div class="main">
                <div style="width: 100%">
                    <el-table
                            border
                            :data="tableData.taskAndDetail">
                        <el-table-column
                                label="检查项">
                            <template slot-scope="scope">
                                <div style="display: flex">
                                    {{scope.row.task.name}}
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column
                                label="分步骤及注意事项">
                            <template slot-scope="scope">
                                <div style="display: flex;" class="scopeDiv" v-for="item in scope.row.detailsList">
                                    <div>
                                        {{item.details.details}}
                                    </div>
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column
                                label="采分点">
                            <template slot-scope="scope">
                                <div v-for="item in scope.row.detailsList">
                                    <div v-for="li in item.userTaskOptions">
                                        <div class="scopeDiv" v-if="li.isChecked == 0 ">
                                            -{{li.option.scope}}
                                        </div>
                                        <div v-else style="display: flex" class="scopeDiv">
                                            {{li.option.scope}}
                                        </div>
                                    </div>
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column
                                label="原因">
                            <template slot-scope="scope">
                                <div v-for="item in scope.row.detailsList">
                                    <div v-for="li in item.userTaskOptions">
                                        <div class="scopeDiv" v-if="li.isChecked == 1 ">
                                        </div>

                                        <div v-else class="scopeDiv" style="display: flex">
                                            {{li.option.remark}}
                                        </div>
                                    </div>
                                </div>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "right",
        data() {
            return {
                errMessage: [],
                permissions: '',
                textarea: '',
                tableData: {userTask: 1},

            }
        },
        methods: {
            submit(index) {
                if (index == 1) {
                    let params = {
                        auditRemark: this.textarea,
                        userTaskId: sessionStorage.reportId,
                    }
                    this.$axios.get(this.URL.uUserTask.auditTask, {params}).then(res => {
                        if (res.status === 200) {
                            this.$message({
                                message: '提交意见成功',
                                type: 'success'
                            });
                        }
                    });
                } else {
                    for (let i in this.tableData.taskAndDetail) {
                        for (let index in this.tableData.taskAndDetail[i].detailsList) {
                            for (let newIndex in this.tableData.taskAndDetail[i].detailsList[index].userTaskOptions) {
                                if (this.tableData.taskAndDetail[i].detailsList[index].userTaskOptions[newIndex].isChecked != 1) {
                                    if (this.tableData.taskAndDetail[i].detailsList[index].userTaskOptions[newIndex].option.remark.trim() != '') {
                                        this.errMessage.push(this.tableData.taskAndDetail[i].detailsList[index].userTaskOptions[newIndex].option.remark)
                                        this.errMessage.join(".")
                                    }
                                }

                            }
                        }
                    }
                    this.textarea = this.errMessage.join(';')
                }

            },


            getData() {
                let loading = this.$loading({
                    lock: true
                });
                let params = {
                    userTaskId: sessionStorage.reportId
                }
                this.$axios.get(this.URL.uUserTask.flyResult, {params}).then(res => {
                    if (res.status === 200) {
                        this.tableData = res.data
                        this.$emit('modelId', this.tableData)
                        this.textarea = res.data.userTask.auditRemark
                    }
                    loading.close()
                })
                    .catch(err => {
                        loading.close()
                    })

            },
        },
        created() {
            //权限
            this.permissions = localStorage.permissions
            this.getData()
        }
    }
</script>

<style lang="less" scoped>
    .first {
        text-align: center;
        background: #409EFF;
    }

    .header-title {
        border: 1px solid rgb(185, 185, 185);
        border-top: none;
        margin-left: -1px;
        .header-title-one {
            width: 100%;
            border-bottom: 1px solid;
            div {
                line-height: 33px;
                text-align: center;
                width: 33%;
                display: flex;
                span {
                    width: 50%;
                    height: 33px;
                    border-left: 1px solid rgb(185, 185, 185);
                    margin-left: -1px;
                }
            }
        }
        .header-title-two {
            display: flex;
            width: 100%;
            .guidance {
                width: 16.4%;
                text-align: center;
                line-height: 33px;
            }
            .suggest {
                width: 65%;
            }
        }
    }

    .main {
        width: 100%;
        .el-table td div {
            /*border-bottom: 1px solid ;*/
        }

    }

    .scopeDiv {
        height: 24px;
        border-bottom: 1px solid;
    }

</style>



// WEBPACK FOOTER //
// src/views/main/dataCenter/labReport/details/right/right.vue